import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-currency-form',
	templateUrl: './currency-form.component.html',
	styleUrl: './currency-form.component.css'
})
export class CurrencyFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Input() name: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			name: [null, [Validators.required]]
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		if (this.name) {
			this.f.name.setValue(this.name);
			this.moduleForm.markAsDirty();
		}
		if (this.uId) {
			this.getDetails();
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getCurrencyDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.name.setValue(data.name);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		let payload = {
			"name": this.f.name.value,
			"id": this.uId
		}
		this.showLoader = true;
		this.apiService.createUpdateCurrency(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Record with name <strong>' + this.f.title.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreCurrency(error.error.encryptid).subscribe({
								next: (data: any) => {
									this.toastr.success("Restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(data);
									this.clearForm();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = "Currency already exists";
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
